
export function WeekCardStatus({ status, isDeadline }: { status: string | undefined; isDeadline: boolean; }) {
    if (isDeadline) {
        return <p className='text-xs text-red-600 dark:text-red-400'>Final Deadline</p>;
    } else if (status === "Review") {
        return <p className='text-xs text-green-600 dark:text-green-400'>In Review</p>;
    }
}
